module.exports = __webpack_public_path__ + "img/logo.c5317fb5.jpg";